<div class="purchase-order-shipment-details m-8">
  <mat-card class="lum-mat-card">
    <mat-card-content>
      <lum-purchase-order-shipments-form></lum-purchase-order-shipments-form>
    </mat-card-content>
  </mat-card>
</div>
